import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
//outsource
import { Row, Col, Layout, Button, message } from "antd";
import { IoReturnUpBackOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { labelDateSelector } from "../../store/var/var.selector";
import { detailBranchSelector } from "../../store/branch/branch.selector";
import { snapIncomeStaffByDate } from "../../store/income/income.action";
import { unSnapIncomeStaff } from "../../store/income/income.action";
import { snapIncome } from "../../store/income/income.action";
import { unSnapIncome } from "../../store/income/income.action";
import {
  allSelector,
  incomeSelector,
} from "../../store/income/income.selector";
import { getStaffsByIds } from "../../store/staff/staff.action";
import IncomeStaffBoard from "./component/income_staff_board";
import IncomeStaffTopBar from "./component/income_staff_top_bar";
import LayoutFooter from "../00_Nav/layout/layout_footer";
import lodash from "lodash";
import moment from "moment";

//components
import "./style.css";
import { staffListSelector } from "../../store/staff/staff.selector";
import { incomeDetailSelector } from "../../store/income_detail/income_detail.selector";
import {
  snapIncomeDetailByDate,
  unSnapIncomeDetail,
} from "../../store/income_detail/income_detail.action";
import { snapJobByBranch, unSnapJob } from "../../store/job/job.action";
import DialogIncomeStaffAdd from "./dialog/dialog_income_staff_add";
import DialogIncomeStaffInput from "./dialog/dialog_income_staff_input";
import { getBranchByShopId } from "../../store/branch/branch.action";
import IncomeStaffJob from "./component/income_staff_Job";

const { Content } = Layout;

const IncomeStaff = () => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const shopId = params?.shopId;
  const navigate = useNavigate();
  const href = `/report/cashup/${shopId}/detail`;
  // -------------------------- STATE --------------------------
  const [data, setData] = useState(null);
  const [edit, setEdit] = useState(true);
  const [block, setBlock] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openInput, setOpenInput] = useState(false);
  const [record, setRecord] = useState(null);
  const [userId, setUserId] = useState(null);

  const [incomeStaff, setIncomeStaff] = useState(null);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const date = useSelector(labelDateSelector);
  const branch = useSelector(detailBranchSelector);
  const branchId = branch?.id || null;
  const checkinList = useSelector(allSelector);
  const staffList = useSelector(staffListSelector);
  const incomeDetailList = useSelector(incomeDetailSelector);
  const incomeListByDate = useSelector(incomeSelector);

  // -------------------------- FUNCTION --------------------------
  const handleAdd = (id) => {
    setOpenAdd(true);
    setUserId(id);
  };
  const handleAddRow = (staff) => {
    if (data) {
      let userId = staff?.id;
      let fullName = `${staff?.firstName} ${staff?.lastName}` || "";
      let income = [];
      let row = {
        userId,
        fullName,
        income,
      };
      setData((data) => {
        return [...data, row];
      });
    }
  };

  const handleNavigate = () => {
    navigate(href);
  };
  const handleNavigateIncome = () => {
    const hrefIncome = `/report/cashup/income-by-staff`;
    navigate(hrefIncome);
  };
  // -------------------------- EFFECT --------------------------

  //get detail branch by shopId
  useEffect(() => {
    if (shopId) {
      dispatch(getBranchByShopId({ shopId }));
    }
  }, [dispatch, shopId]);

  // get Staff info in coop
  useEffect(() => {
    if (branch) {
      const coop = branch?.coop;
      if (coop) {
        dispatch(
          getStaffsByIds({ ids: coop }, (res) => {
            if (res.status === 200) {
              //
            }
          })
        );
      }
    }
  }, [dispatch, branch]);

  //Get all Jobs Branch
  useEffect(() => {
    if (date && branch) {
      const from = moment(date, "DD/MM/YYYY");
      const to = moment(date, "DD/MM/YYYY");
      dispatch(snapJobByBranch({ from, to, branch: branch?.id }, () => {}));
    }
    return () => dispatch(unSnapJob());
  }, [dispatch, date, branch]);

  //Get income in date, if income is available then lock input incomes
  useEffect(() => {
    if (date && branchId) {
      dispatch(
        snapIncome({ date, branch: branchId }, (res) => {
          if (res === false) {
            // setBlock(false);
            // setEdit(true);
          } else {
            let data = res?.staffs || null;
            // setEdit(false);
            // setBlock(true);
            // console.log(data);
          }
        })
      );
      return () => dispatch(unSnapIncome());
    }
  }, [dispatch, date, branchId]);

  useEffect(() => {
    if (date && branchId) {
      dispatch(snapIncomeDetailByDate({ date, branch: branchId }));

      return () => dispatch(unSnapIncomeDetail());
    }
  }, [dispatch, date, branchId]);

  // snap checkin by date by branch id
  useEffect(() => {
    if (date && branchId) {
      dispatch(snapIncomeStaffByDate({ date, branch: branchId }));

      return () => dispatch(unSnapIncomeStaff());
    }
  }, [dispatch, date, branchId]);

  // get data by income detail, if incomes data is available then setData = incomes
  useEffect(() => {
    if (incomeDetailList?.length === 0 && incomeListByDate && staffList) {
      message.warning(`Data from ${date}  and earlier can only be viewed`);
      setEdit(false);
      const staffs = incomeListByDate?.staffs;
      setIncomeStaff(staffs);
    } else {
      setEdit(true);
      const staffIds =
        incomeDetailList?.length > 0 &&
        incomeDetailList?.map((item) => item?.userId);
      const uniqIds = lodash.uniq(staffIds);
      // console.log({uniqIds});
      const update = uniqIds?.map((userId) => {
        const income = incomeDetailList?.filter(
          (item) => item?.userId === userId
        );
        const userInfo = staffList?.find((user) => user?.id === userId);
        const fullName = `${userInfo?.firstName} ${userInfo?.lastName}`;
        return {
          userId: userId,
          income,
          fullName,
        };
      });
      setIncomeStaff(update);
    }
  }, [incomeDetailList, incomeListByDate, staffList]);

  // neu co checkin
  useEffect(() => {
    if (checkinList && staffList) {
      const ips = checkinList?.map((item) => item?.user);
      const uniqIds = lodash.uniq(ips);
      const newIncome = uniqIds?.map((userId) => {
        const income = [];
        const userInfo = staffList?.find((user) => user?.id === userId);
        const fullName = `${userInfo?.firstName} ${userInfo?.lastName}`;
        return {
          userId: userId,
          income,
          fullName,
        };
      });
      // const incomeData = incomeStaff ? incomeStaff : [];
      const update = lodash.unionBy(incomeStaff, newIncome, "userId");
      // console.log({ incomeData, newIncome, update });
      setData(update);
    }
  }, [checkinList, staffList, incomeStaff]);

  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    return (
      <>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderBackBtn()}
        </Col>
        <Row gutter={[20, 20]} className="section-cashup">
          <Col xl={24} lg={24} md={24} xs={24}>
            <IncomeStaffTopBar
              edit={edit}
              setEdit={setEdit}
              href={href}
              data={data}
              branch={branch}
              handleAddRow={handleAddRow}
              block={block}
            />
          </Col>
          <Col span={24}>
            <IncomeStaffJob />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <IncomeStaffBoard edit={edit} data={data} handleAdd={handleAdd} />
          </Col>
        </Row>
      </>
    );
  };

  const renderBackBtn = () => {
    return (
      <Row style={{ margin: "20px 0px" }}>
        <Col xl={12} lg={12} md={24} xs={24}></Col>
        <Col align="right" xl={12} lg={12} md={24} xs={24}>
          <Button onClick={handleNavigate} type="link">
            Return Cashup Detail
          </Button>
          {/* |
          <Button onClick={handleNavigateIncome} type="link">
            Return Income Staff List
          </Button> */}
        </Col>
      </Row>
    );
  };

  const renderDialogAdd = () => {
    return (
      <DialogIncomeStaffAdd
        open={openAdd}
        setOpen={setOpenAdd}
        setOpenInput={setOpenInput}
        setRecord={setRecord}
        userId={userId}
        staffList={staffList}
      />
    );
  };

  const renderDialogInput = () => {
    return (
      <DialogIncomeStaffInput
        open={openInput}
        setOpen={setOpenInput}
        record={record}
        setRecord={setRecord}
        userId={userId}
        staffList={staffList}
        incomeDetailList={incomeDetailList}
      />
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Layout style={{ position: "relative" }} className="full">
      <Content className="content">
        <Row align="center">
          <Col xl={20} lg={20} md={24} xs={24}>
            {renderBody()}
            {renderDialogAdd()}
            {renderDialogInput()}
          </Col>
        </Row>
      </Content>
      <LayoutFooter />
      {/* <Breakpoint setMobile={setMobile} /> */}
    </Layout>
  );
};

export default IncomeStaff;
